import type { UI } from '@/v2/types';
import {
  Box,
  Container,
  Disclosure,
  Flex,
  Heading,
  Text as RooText,
} from '@qga/roo-ui/components';

import ToggleContent from '@shared/v2/components/ToggleContent';
import htmlToReact from '@shared/v2/utils/htmlToReact';

// Legacy
import LinkButton from '@/components/LinkButton';
import withProps from '@/components/withProps';
import Map from '../PackageOverview/components/HotelLocation/components/Map';
import Facilities from './components/Facilities';

interface AboutHotelProps {
  propertyContent: UI.Property;
  procuredOffer: UI.ProcuredOffer | null;
}

const Subheading = withProps({
  color: 'greys.charcoal',
  fontWeight: '400',
  fontSize: ['18px', null, '22px'],
  lineHeight: ['27px', null, '33px'],
  mb: [4, 6],
})(Heading.h4) as React.FC<any>;

const Text = withProps({
  fontSize: ['sm', null, 'base'],
})(RooText) as React.FC<any>;

const AboutHotel = ({ propertyContent, procuredOffer }: AboutHotelProps) => (
  <Container>
    <Disclosure headerTitle="About this hotel" expand variant="large">
      <Flex flexDirection="column" width={[null, null, '75%']} gap={[4, 6]}>
        <Box>
          {procuredOffer ? (
            <>
              <Subheading>{propertyContent.name}</Subheading>
              {propertyContent.tagline && (
                <Heading.h5
                  mb={[4, 6]}
                  color="greys.charcoal"
                  fontSize={['16px', null, '20px']}
                  fontWeight={400}
                >
                  {propertyContent.tagline}
                </Heading.h5>
              )}
              <Text>
                {htmlToReact(propertyContent.description, {
                  addParagraphs: true,
                })}
              </Text>
            </>
          ) : (
            <Subheading marginBottom="0">{propertyContent.name}</Subheading>
          )}
        </Box>

        <Box>
          <Subheading>Getting there</Subheading>
          <Flex flexDirection="column" gap="2">
            <Flex>
              <Box width="154px">
                <Text fontWeight="bold" m={0} p={0}>
                  Check-in time
                </Text>
              </Box>
              <Text>{`From ${propertyContent.checkInAfter}`}</Text>
            </Flex>
            <Flex>
              <Box width="154px">
                <Text fontWeight="bold">Check-out time</Text>
              </Box>
              <Text>{`Before ${propertyContent.checkOutBefore}`}</Text>
            </Flex>
            <Flex>
              <Box width="154px">
                <Text fontWeight="bold">Hotel address</Text>
              </Box>
              <Flex
                flexDirection="column"
                justifyContent="start"
                flex="1"
                alignItems="start"
              >
                <Text>{propertyContent.address}</Text>
                <ToggleContent
                  toggle={(show) => (
                    /* @ts-ignore */
                    <LinkButton onClick={show} ml="0" mt="1">
                      <Text textDecoration="underline">View on map</Text>
                    </LinkButton>
                  )}
                  content={(hide) => (
                    /* @ts-ignore */
                    <Map propertyContent={propertyContent} onClose={hide} />
                  )}
                />
              </Flex>
            </Flex>
          </Flex>
        </Box>

        <Box>
          <Subheading>Hotel facilities</Subheading>
          <Box>
            <Facilities facilities={propertyContent.facilities} />
          </Box>
        </Box>
      </Flex>
    </Disclosure>
  </Container>
);

export default AboutHotel;
